import { render, staticRenderFns } from "./UpcomingEventDetails.vue?vue&type=template&id=3d1fb7be&scoped=true&"
import script from "./UpcomingEventDetails.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1fb7be",
  null
  
)

export default component.exports